/**
 * Pasos del wizard de impresión.
 * El template asume que cada índice de processTypes tiene un paso en data.
 * Estas funciones evitan leer `.result` cuando la plantilla no generó pasos.
 */

/**
 * @param {Array<Object>|null|undefined} steps
 * @param {number} index
 * @returns {Object|null}
 */
export function getProcessStep(steps, index) {
    if (!Array.isArray(steps) || index < 0 || index >= steps.length) {
        return null
    }
    return steps[index] || null
}

/**
 * Misma regla que el botón de imprimir: cantidad 0 o por encima del máximo.
 * Sin paso, el botón queda bloqueado para no evaluar `.result` sobre undefined.
 *
 * @param {Object|null|undefined} step
 * @returns {boolean}
 */
export function isPrintQuantityInvalid(step) {
    if (!step) {
        return true
    }
    const quantity = parseInt(step.result, 10)
    const max = parseInt(step.max, 10)
    return quantity === 0 || quantity > max
}

/**
 * `format.data` llega como JSON string. Un valor vacío o ilegible no abre el wizard.
 *
 * @param {*} formatData
 * @returns {*|null}
 */
export function parsePrintFormatData(formatData) {
    if (typeof formatData !== 'string' || formatData.trim() === '') {
        return null
    }
    try {
        return JSON.parse(formatData)
    } catch (parseError) {
        return null
    }
}
